import { render, staticRenderFns } from "./LabelSticker.vue?vue&type=template&id=7b6d778e&scoped=true"
import script from "./LabelSticker.vue?vue&type=script&lang=js"
export * from "./LabelSticker.vue?vue&type=script&lang=js"
import style0 from "./LabelSticker.vue?vue&type=style&index=0&id=7b6d778e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6d778e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6d778e')) {
      api.createRecord('7b6d778e', component.options)
    } else {
      api.reload('7b6d778e', component.options)
    }
    module.hot.accept("./LabelSticker.vue?vue&type=template&id=7b6d778e&scoped=true", function () {
      api.rerender('7b6d778e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/processWorksheet/LabelSticker.vue"
export default component.exports